
(function () {
  var wrapper = document.getElementById('hb-{{ section.id }}');
  if (!wrapper) return;
  var slides = Array.from(wrapper.querySelectorAll('[data-hb-slide]'));
  var dots = Array.from(wrapper.querySelectorAll('[data-hb-dot]'));
  if (slides.length < 2) return;

  var current = 0;
  var timer;

  // Translation helper
  window.AppT = window.GentlyTranslations || {};
  // var delay   = {{ section.settings.autoplay_ms | default: 4000 }};
  var delay = 4000;

  function goTo(n) {
    slides[current].classList.remove('is-active');
    dots[current] && dots[current].classList.remove('is-active');
    current = (n + slides.length) % slides.length;
    slides[current].classList.add('is-active');
    dots[current] && dots[current].classList.add('is-active');
  }

  function startTimer() {
    clearInterval(timer);
    timer = setInterval(function () { goTo(current + 1); }, delay);
  }

  dots.forEach(function (d) {
    d.addEventListener('click', function () {
      goTo(parseInt(d.getAttribute('data-hb-dot'), 10));
      startTimer();
    });
  });

  /* Swipe support */
  var sx = 0;
  var sl = wrapper.querySelector('[data-hb-slider]');
  sl.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
  sl.addEventListener('touchend', function (e) {
    var dx = sx - e.changedTouches[0].clientX;
    if (Math.abs(dx) > 40) { goTo(dx > 0 ? current + 1 : current - 1); startTimer(); }
  });

  startTimer();
})();

// AJAX Load More for Collection Grid
function initAjaxLoadMore() {
  const container = document.querySelector('.gently-katpage-container');
  if (!container) return;

  const grid = container.querySelector('.gently-katpage-grid');
  if (!grid) return;

  container.addEventListener('click', function (e) {
    const loadMoreBtn = e.target.closest('.gently-katpage-more__btn');
    if (!loadMoreBtn) return;

    e.preventDefault();

    const url = loadMoreBtn.getAttribute('href');
    if (!url) return;

    const originalText = loadMoreBtn.textContent;
    loadMoreBtn.textContent = window.AppT ? window.AppT.loading || 'Loading...' : 'Loading...';
    loadMoreBtn.style.pointerEvents = 'none';
    loadMoreBtn.style.opacity = '0.7';

    fetch(url)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const newProducts = doc.querySelectorAll('.gently-katpage-grid > *');
        newProducts.forEach(product => {
          grid.appendChild(product);
        });

        if (typeof ReloadSmartWishlist !== "undefined" && $.isFunction(ReloadSmartWishlist)) {
            ReloadSmartWishlist();
        }

        const newPagination = doc.querySelector('.gently-katpage-more');
        const currentPagination = container.querySelector('.gently-katpage-more');

        if (currentPagination) {
          if (newPagination) {
            currentPagination.outerHTML = newPagination.outerHTML;
          } else {
            currentPagination.remove();
          }
        }
      })
      .catch(err => {
        console.error('Error loading products:', err);
        loadMoreBtn.textContent = originalText;
        loadMoreBtn.style.pointerEvents = 'auto';
        loadMoreBtn.style.opacity = '1';
        window.location.href = url;
      });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAjaxLoadMore);
} else {
  initAjaxLoadMore();
}

// smartwishlist
function initSmartWishlist() {
  const processWishlist = () => {
    document.querySelectorAll('.smartwishlist').forEach((wishlist) => {
      const faIcon = wishlist.querySelector('.fa');

      if (faIcon && !wishlist.querySelector('.svg-wishlist')) {
        faIcon.remove();

        wishlist.insertAdjacentHTML(
          'beforeend',
          `<svg class="svg-wishlist" viewBox="0 0 24 24">
            <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
          </svg>`
        );
      }
    });
  };

  processWishlist();

  const addWishlistGridClasses = () => {
    document.querySelectorAll('#bookmarks .product:not(.kg-formatted)').forEach(productEl => {
      productEl.classList.add('kg-formatted');
      
      let wrapper = productEl.parentElement;
      if (wrapper && wrapper.id !== 'bookmarks' && !wrapper.classList.contains('row')) {
        if (!wrapper.classList.contains('kg-wishlist-col')) {
          wrapper.classList.add('kg-wishlist-col');
        }
      } else {
        productEl.classList.add('kg-wishlist-col');
      }

      // Re-format into kg-pcard structure
      productEl.classList.add('kg-pcard');

      const imgWrap = productEl.querySelector('.image');
      if (imgWrap) imgWrap.classList.add('kg-pcard__img');

      const bodyWrap = productEl.querySelector('.text');
      if (bodyWrap) bodyWrap.classList.add('kg-pcard__body');

      const titleLink = productEl.querySelector('.product_title a');
      if (titleLink) titleLink.classList.add('kg-pcard__name');

      // Prices & Discount formatting
      const pricePs = Array.from(productEl.querySelectorAll('.text p'));
      const priceP = pricePs.find(p => !p.className);
      if (priceP) {
        let compareRaw = 0;
        let currentRaw = 0;
        let compareStr = '';
        let currentStr = '';

        let strike = priceP.querySelector('strike, del, s');
        if (strike) {
          let rawCompareStr = strike.textContent;
          let matchCompare = rawCompareStr.match(/Rp\s*([\d.,]+)/i);
          if (matchCompare) {
            compareStr = 'Rp ' + matchCompare[1].replace(/,00/g, '');
            if (matchCompare[1].includes(',')) {
              compareRaw = parseInt(matchCompare[1].replace(/[\.,]/g, '').slice(0, -2)) || 0;
            } else {
              compareRaw = parseInt(matchCompare[1].replace(/\./g, '')) || 0;
            }
          }
          
          let restText = priceP.textContent.replace(rawCompareStr, '');
          let matchCurrent = restText.match(/Rp\s*([\d.,]+)/i);
          if (matchCurrent) {
            currentStr = 'Rp ' + matchCurrent[1].replace(/,00/g, '');
            if (matchCurrent[1].includes(',')) {
              currentRaw = parseInt(matchCurrent[1].replace(/[\.,]/g, '').slice(0, -2)) || 0;
            } else {
              currentRaw = parseInt(matchCurrent[1].replace(/\./g, '')) || 0;
            }
          }
        } else {
          let matchCurrent = priceP.textContent.match(/Rp\s*([\d.,]+)/i);
          if (matchCurrent) {
            currentStr = 'Rp ' + matchCurrent[1].replace(/,00/g, '');
            if (matchCurrent[1].includes(',')) {
              currentRaw = parseInt(matchCurrent[1].replace(/[\.,]/g, '').slice(0, -2)) || 0;
            } else {
              currentRaw = parseInt(matchCurrent[1].replace(/\./g, '')) || 0;
            }
          }
        }

        if (currentStr) {
          let newHtml = `<div class="kg-pcard__prices">`;
          if (compareStr && compareRaw > currentRaw) {
            newHtml += `<div class="kg-pcard__price-top"><span class="kg-pcard__orig">${compareStr}</span></div>`;
            let discount = Math.round(((compareRaw - currentRaw) / compareRaw) * 100);
            newHtml += `<div class="kg-pcard__sale">
                          <span class="kg-pcard__price">${currentStr}</span>
                          <span class="kg-pcard__disc">-${discount}%</span>
                        </div>`;
          } else {
            newHtml += `<div class="kg-pcard__sale"><span class="kg-pcard__price">${currentStr}</span></div>`;
          }
          newHtml += `</div>`;
          
          // Add dummy rating just to match aesthetics
          newHtml += `<div class="kg-pcard__rating"><svg viewBox="0 0 24 24"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"></path></svg><span>4.9</span></div>`;
          
          priceP.outerHTML = newHtml;
        }
      }

      // Detect language for fallback text
      const isIndo = (document.documentElement.lang || '').toLowerCase().startsWith('id') || 
                     (window.Shopify && (window.Shopify.locale || '').toLowerCase().startsWith('id'));
      const defaultDelete = isIndo ? 'Hapus' : 'Delete';
      const defaultAddToCart = isIndo ? 'Tambah ke Keranjang' : 'Add to Cart';
      const defaultSoldOut = isIndo ? 'Habis Terjual' : 'Sold Out';

      // Buttons formatting: assign pending class initially to avoid flash of wrong color
      let removeBtn, addBtn;
      const actionsWrap = productEl.querySelector('.buttons');
      if (actionsWrap) {
        actionsWrap.className = 'kg-pcard__cta';
        removeBtn = actionsWrap.querySelector('.removebutton');
        if (removeBtn) {
          removeBtn.classList.add('kg-pcard__btn', 'kg-pcard__btn--pending');
          removeBtn.textContent = window.AppT ? window.AppT.delete || defaultDelete : defaultDelete;
        }
        addBtn = actionsWrap.querySelector('.addbutton');
        if (addBtn) {
          addBtn.classList.add('kg-pcard__btn', 'kg-pcard__btn--pending');
          addBtn.textContent = window.AppT ? window.AppT.addToCart || defaultAddToCart : defaultAddToCart;
        }
      }

      // Check stock availability & vendor via Shopify AJAX Product API
      let productHandle = '';
      if (titleLink && titleLink.getAttribute('href')) {
        const href = titleLink.getAttribute('href');
        const match = href.match(/\/products\/([^?#]+)/);
        if (match) productHandle = match[1];
      }

      if (productHandle) {
        // Helper function to apply theme styling and stock availability
        const applyThemeAndStock = (prod) => {
          if (!prod) return;
          const vendor = (prod.vendor || '').toLowerCase();
          const isMomicare = vendor.includes('momicare') || vendor.includes('momi care') || vendor.includes('mom care') || vendor.includes('mom-care');
          
          // Remove pending class and set final theme color class (mami/baby) directly
          if (removeBtn) {
            removeBtn.classList.remove('kg-pcard__btn--pending');
            removeBtn.classList.add(isMomicare ? 'kg-pcard__btn--buy-mami' : 'kg-pcard__btn--buy-baby');
          }
          if (addBtn) {
            addBtn.classList.remove('kg-pcard__btn--pending');
            addBtn.classList.add(isMomicare ? 'kg-pcard__btn--cart-mami' : 'kg-pcard__btn--cart-baby');
          }

          // Handle sold out status
          if (prod.available === false) {
            if (addBtn) {
              addBtn.classList.add('is-soldout');
              addBtn.disabled = true;
              addBtn.textContent = window.AppT ? window.AppT.soldOut || defaultSoldOut : defaultSoldOut;
            }
          }
        };

        // Cache lookup: check sessionStorage for existing product details to eliminate async delay FOUC
        const cacheKey = `vendor_${productHandle}`;
        const cachedProd = sessionStorage.getItem(cacheKey);

        if (cachedProd) {
          try {
            const prod = JSON.parse(cachedProd);
            applyThemeAndStock(prod);
          } catch (e) {
            sessionStorage.removeItem(cacheKey);
          }
        } else {
          // Fetch product data if not cached
          fetch(`${(window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'}products/${productHandle}.js`)
            .then(res => res.json())
            .then(prod => {
              if (prod) {
                // Save to sessionStorage cache
                sessionStorage.setItem(cacheKey, JSON.stringify(prod));
                applyThemeAndStock(prod);
              }
            })
            .catch(err => console.error('Error checking wishlist item details:', err));
        }
      }
    });
  };

  addWishlistGridClasses();
  const gridObserver = new MutationObserver(addWishlistGridClasses);
  gridObserver.observe(document.body, { childList: true, subtree: true });

  const observer = new MutationObserver(processWishlist);

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // ── Hapus card dari wishlist via tombol "Hapus" ──
  function calculateWishlistCount() {
    const bookmarks = document.getElementById('bookmarks');
    if (bookmarks) {
      const count = bookmarks.querySelectorAll('.product').length;
      localStorage.setItem('kg_wishlist_count', count);
      return count;
    }
    
    const cachedCount = localStorage.getItem('kg_wishlist_count');
    if (cachedCount !== null) {
      return parseInt(cachedCount, 10);
    }

    let count = getWishlistCountFromCookie();
    if (count === 0) {
      count = getWishlistCountFromDOM();
    }
    localStorage.setItem('kg_wishlist_count', count);
    return count;
  }

  function updateWishlistCount() {
    fixWishlistBadge();

    // Kalau wishlist kosong, tampilkan pesan
    const remaining = calculateWishlistCount();
    if (remaining <= 0) {
      const bookmarks = document.getElementById('bookmarks');
      if (bookmarks && !bookmarks.querySelector('.kg-wishlist-empty')) {
        const emptyMsg = document.createElement('div');
        emptyMsg.className = 'kg-wishlist-empty';
        emptyMsg.style.cssText = 'text-align:center;padding:60px 20px;font-size:16px;color:#6b7280;';
        emptyMsg.innerHTML = '<p style="font-size:48px;margin-bottom:16px;">&#x1F494;</p><p>Wishlist kamu masih kosong</p>';
        bookmarks.appendChild(emptyMsg);
      }
    }
  }

  document.addEventListener('click', function (e) {
    const removeBtn = e.target.closest('.removebutton');
    if (!removeBtn) return;
    const bookmarks = document.getElementById('bookmarks');
    if (!bookmarks) return;
    if (!bookmarks.contains(removeBtn)) return;

    // JANGAN panggil e.preventDefault() atau e.stopPropagation() di sini!
    // Ini krusial agar event click bisa diteruskan ke handler internal Smart Wishlist app
    // sehingga app bisa menghapus produk secara permanen dari server & cookie mereka.

    const card = removeBtn.closest('.kg-wishlist-col') || removeBtn.closest('.product');
    if (!card) return;

    // Hapus juga secara lokal dari cookie jika ada
    const productLink = card.querySelector('.product_title a, .kg-pcard__name');
    let productHandle = '';
    if (productLink && productLink.getAttribute('href')) {
      const href = productLink.getAttribute('href');
      const match = href.match(/\/products\/([^?#]+)/);
      if (match) productHandle = match[1];
    }

    if (productHandle) {
      const cookieMatch = document.cookie.match(/(?:^|;\s*)smartwishlist=([^;]*)/);
      if (cookieMatch && cookieMatch[1]) {
        const decoded = decodeURIComponent(cookieMatch[1]);
        const handles = decoded.split(',').filter(h => h.trim() !== '' && h.trim() !== productHandle);
        const newVal = handles.join(',');
        document.cookie = 'smartwishlist=' + encodeURIComponent(newVal) + ';path=/;max-age=31536000';
      }
    }

    // Animasi fade out
    card.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
    card.style.opacity = '0';
    card.style.transform = 'scale(0.95)';

    setTimeout(function () {
      card.remove();
      updateWishlistCount();

      // Kalau wishlist kosong, tampilkan pesan
      const remaining = document.querySelectorAll('#bookmarks .product').length;
      if (remaining <= 0) {
        const bk = document.getElementById('bookmarks');
        if (bk && !bk.querySelector('.kg-wishlist-empty')) {
          const emptyMsg = document.createElement('div');
          emptyMsg.className = 'kg-wishlist-empty';
          emptyMsg.style.cssText = 'text-align:center;padding:60px 20px;font-size:16px;color:#6b7280;';
          emptyMsg.innerHTML = '<p style="font-size:48px;margin-bottom:16px;">&#x1F494;</p><p>Wishlist kamu masih kosong</p>';
          bk.appendChild(emptyMsg);
        }
      }
    }, 300);
  });

  // ── Tambah ke Keranjang dari wishlist → panggil CartEngine popup ──
  document.addEventListener('click', function (e) {
    const addBtn = e.target.closest('.addbutton');
    if (!addBtn) return;
    const bookmarks = document.getElementById('bookmarks');
    if (!bookmarks || !bookmarks.contains(addBtn)) return;

    e.preventDefault();
    e.stopPropagation();

    if (!window.CartEngine || typeof window.CartEngine.addFromForm !== 'function') {
      console.warn('CartEngine belum siap');
      return;
    }

    // Cari variant ID dari smartwishlist element di card
    const card = addBtn.closest('.product') || addBtn.closest('.kg-pcard');
    if (!card) return;

    const smartWishEl = card.querySelector('.smartwishlist[data-variant]');
    const variantId = smartWishEl ? smartWishEl.getAttribute('data-variant') : null;

    // Fallback: cari dari data-variantid atau href
    let finalVariantId = variantId;
    if (!finalVariantId) {
      finalVariantId = addBtn.getAttribute('data-variantid') || addBtn.getAttribute('data-variant');
    }
    if (!finalVariantId) {
      const match = (addBtn.getAttribute('href') || '').match(/(?:id|variant)=(\d+)/);
      if (match) finalVariantId = match[1];
    }

    if (!finalVariantId) {
      console.warn('Variant ID tidak ditemukan di card wishlist');
      return;
    }

    // Buat form sementara biar bisa pakai CartEngine.addFromForm
    const tempForm = document.createElement('form');
    tempForm.method = 'post';
    tempForm.action = '/cart/add';

    const idInput = document.createElement('input');
    idInput.type = 'hidden';
    idInput.name = 'id';
    idInput.value = finalVariantId;
    tempForm.appendChild(idInput);

    const qtyInput = document.createElement('input');
    qtyInput.type = 'hidden';
    qtyInput.name = 'quantity';
    qtyInput.value = '1';
    tempForm.appendChild(qtyInput);

    document.body.appendChild(tempForm);

    // Ubah teks tombol sementara
    const origText = addBtn.textContent;
    addBtn.textContent = window.GentlyTranslations ? window.GentlyTranslations.adding || 'Adding...' : 'Adding...';
    addBtn.style.pointerEvents = 'none';
    addBtn.style.opacity = '0.7';

    window.CartEngine.addFromForm(tempForm)
      .then(function () {
        addBtn.textContent = origText;
        addBtn.style.pointerEvents = '';
        addBtn.style.opacity = '';
      })
      .catch(function (err) {
        if (!err || !err.handled) {
          console.error('Error add to cart dari wishlist:', err);
        }
        addBtn.textContent = origText;
        addBtn.style.pointerEvents = '';
        addBtn.style.opacity = '';
      })
      .finally(function () {
        tempForm.remove();
      });
  });

  // ── Fix wishlist badge count dari app Smart Wishlist ──
  // App inject angka yang salah di .topbadge.
  // Kita baca cookie 'smartwishlist' langsung untuk hitung jumlah item yang benar,
  // dan juga hitung elemen .smartwishlist.bookmarked di halaman sebagai fallback.

  function getWishlistCountFromCookie() {
    const match = document.cookie.match(/(?:^|;\s*)smartwishlist=([^;]*)/);
    if (!match || !match[1]) return 0;
    const decoded = decodeURIComponent(match[1]).trim();
    if (!decoded || decoded === '') return 0;
    // Ambil unique items saja untuk menghindari duplikat
    const items = decoded.split(',').map(item => item.trim()).filter(item => item !== '');
    const uniqueItems = [...new Set(items)];
    return uniqueItems.length;
  }

  function getWishlistCountFromDOM() {
    // Ambil semua elemen wishlist yang di-bookmark
    const bookmarkedElements = document.querySelectorAll('.smartwishlist.bookmarked');
    const productIds = [];
    bookmarkedElements.forEach(el => {
      const productId = el.getAttribute('data-product');
      if (productId) {
        productIds.push(productId);
      }
    });
    // Ambil jumlah product ID yang unik untuk menghindari hitungan ganda akibat clone slide dari Swiper
    return new Set(productIds).size;
  }

  let isUpdatingBadge = false;

  function fixWishlistBadge() {
    if (isUpdatingBadge) return;
    isUpdatingBadge = true;

    let count = calculateWishlistCount();

    document.querySelectorAll('a.hb-header__icon[href="/a/wishlist"]').forEach(link => {
      // Bersihkan/sembunyikan elemen lain atau text node yang di-inject oleh app Smart Wishlist
      Array.from(link.childNodes).forEach(node => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          if (!node.classList.contains('topbadge') && node.tagName.toLowerCase() !== 'svg') {
            node.style.display = 'none';
            node.remove();
          }
        } else if (node.nodeType === Node.TEXT_NODE) {
          if (node.textContent.trim() !== '') {
            node.textContent = '';
          }
        }
      });

      let badge = link.querySelector('.topbadge');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'topbadge';
          link.style.position = 'relative';
          link.appendChild(badge);
        }
        if (badge.textContent !== String(count)) {
          badge.textContent = count;
        }
        badge.style.display = '';
      } else if (badge) {
        badge.style.display = 'none';
      }
    });

    isUpdatingBadge = false;
  }

  // Jalankan fix berkali-kali karena app bisa inject kapan saja
  setTimeout(fixWishlistBadge, 500);
  setTimeout(fixWishlistBadge, 1500);
  setTimeout(fixWishlistBadge, 3000);
  setTimeout(fixWishlistBadge, 5000);

  // Observe perubahan pada link wishlist — kalau app inject/ubah badge, kita override
  const wishlistLinks = document.querySelectorAll('a.hb-header__icon[href="/a/wishlist"]');
  wishlistLinks.forEach(link => {
    const badgeObserver = new MutationObserver(function () {
      if (!isUpdatingBadge) {
        fixWishlistBadge();
      }
    });
    badgeObserver.observe(link, { childList: true, subtree: true, characterData: true });
  });

  // Helper untuk menampilkan toast notification
  function showWishlistToast(message) {
    let toast = document.getElementById('kg-wishlist-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'kg-wishlist-toast';
      toast.className = 'kg-toast';
      // Biarkan CSS yang handle positioning (dengan media query responsive)
      toast.style.cssText = `
        z-index: 99999;
      `;
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.style.display = 'block';

    if (window.wishlistToastTimeout) {
      clearTimeout(window.wishlistToastTimeout);
    }

    window.wishlistToastTimeout = setTimeout(function () {
      toast.style.display = 'none';
    }, 3000);
  }

  // Trigger update badge dan toast ketika user klik tombol love di halaman mana pun
  // Gunakan useCapture (parameter ketiga = true) agar kita tetap menangkap click
  // meskipun aplikasi Smart Wishlist memanggil e.stopPropagation() untuk memblokir event.
  document.addEventListener('click', function (e) {
    const wishBtn = e.target.closest('.kg-pcard__wish, .smartwishlist');
    if (wishBtn) {
      const smartEl = wishBtn.classList.contains('smartwishlist') ? wishBtn : wishBtn.querySelector('.smartwishlist');
      if (smartEl) {
        const isRemoving = smartEl.classList.contains('bookmarked');
        let currentCount = parseInt(localStorage.getItem('kg_wishlist_count') || '0', 10);
        if (isRemoving) {
          showWishlistToast('Produk berhasil dihapus dari wishlist!');
          currentCount = Math.max(0, currentCount - 1);
        } else {
          showWishlistToast('Produk berhasil ditambahkan ke wishlist!');
          currentCount = currentCount + 1;
        }
        localStorage.setItem('kg_wishlist_count', currentCount);
      }

      // Update secepatnya (instant) untuk feedback visual dari DOM,
      // lalu jalankan lagi dengan delay untuk sinkronisasi cookie setelah AJAX selesai
      setTimeout(fixWishlistBadge, 50);
      setTimeout(fixWishlistBadge, 300);
      setTimeout(fixWishlistBadge, 800);
      setTimeout(fixWishlistBadge, 1800);
    }
  }, true);

  // ── Ubah list strip/bullet menjadi centang di Detail Produk ──
  function convertListToCheckmarks() {
    document.querySelectorAll('.detail-content-inner').forEach(wrapper => {
      wrapper.querySelectorAll('p, li').forEach(el => {
        const text = el.textContent.trim();
        // Deteksi jika teks diawali dengan "-", "•", "*", atau "–"
        if (/^[-\u2022*\u2013]\s*/.test(text)) {
          const cleanText = text.replace(/^[-\u2022*\u2013]\s*/, '');
          const svgMarkup = `<svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.97261 9.86771L0.499609 6.39371C0.340293 6.23453 0.21391 6.04552 0.127681 5.83747C0.0414529 5.62942 -0.00292969 5.40642 -0.00292969 5.18121C-0.00292969 4.956 0.0414529 4.733 0.127681 4.52495C0.21391 4.3169 0.340293 4.12789 0.499609 3.96871C0.821348 3.64744 1.25744 3.467 1.71211 3.467C2.16678 3.467 2.60287 3.64744 2.92461 3.96871L5.09961 6.14171C5.14345 6.18531 5.20277 6.20979 5.26461 6.20979C5.32644 6.20979 5.38576 6.18531 5.42961 6.14171L11.0696 0.50171C11.3913 0.180445 11.8274 0 12.2821 0C12.7368 0 13.1729 0.180445 13.4946 0.50171C13.6539 0.660889 13.7803 0.849904 13.8665 1.05795C13.9528 1.266 13.9971 1.489 13.9971 1.71421C13.9971 1.93942 13.9528 2.16242 13.8665 2.37047C13.7803 2.57852 13.6539 2.76753 13.4946 2.92671L6.55461 9.86771C6.21218 10.21 5.74781 10.4024 5.26361 10.4024C4.77941 10.4024 4.31504 10.21 3.97261 9.86771Z" fill="#444A58"/></svg>`;
          el.innerHTML = `<span class="check-icon">${svgMarkup}</span>${cleanText}`;
          el.classList.add('custom-check-item');
        }
      });
    });
  }
  convertListToCheckmarks();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSmartWishlist);
} else {
  initSmartWishlist();
}
// end smartwishlist

// Global anchor redirect helper for non-homepage pages
document.addEventListener('click', function(e) {
  // Intercept Loox "Continue" button click before Loox's scripts can trigger a redirect
  const looxContainer = e.target.closest('.loox-widget, [id*="loox"], [class*="loox"]');
  if (looxContainer) {
    const btn = e.target.closest('button, a, div[role="button"], span');
    if (btn && btn.textContent.toLowerCase().includes('continue')) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      // Reload the page to clear the modal and show the newly submitted review
      window.location.reload();
      return;
    }
  }

  const link = e.target.closest('a');
  if (!link) return;

  const href = link.getAttribute('href');
  if (!href) return;

  // Fix for Loox "Continue" button redirecting to homepage instead of staying on product page
  if (href.startsWith('/?ref=loox') || href.includes('loox_review_submitted')) {
    e.preventDefault();
    const urlObj = new URL(href, window.location.origin);
    window.location.href = window.location.pathname + urlObj.search + (urlObj.hash || window.location.hash);
    return;
  }

  // Skip redirect for Loox review app links
  if (link.closest('[class*="loox"], [id*="loox"], .loox-widget, .loox-review')) return;
  if (href.toLowerCase().includes('loox')) return;

  const hashIdx = href.indexOf('#');
  if (hashIdx !== -1) {
    const hash = href.substring(hashIdx);
    if (hash.length > 1) {
      try {
        const target = document.querySelector(hash);
        if (!target) {
          e.preventDefault();
          const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const separator = rootUrl.endsWith('/') ? '' : '/';
          window.location.href = rootUrl + separator + hash;
        }
      } catch (err) {
        // Ignore invalid selectors
      }
    }
  }
}, true);

// Fallback for Loox review redirects
// Loox sometimes forces a redirect to the homepage after a review is submitted.
// We store the last visited product URL and bounce them back if this happens.
// if (window.location.pathname.includes('/products/')) {
//   sessionStorage.setItem('kg_last_product_url', window.location.pathname);
// } else if (window.location.pathname === '/' && window.location.search.includes('loox_review_submitted')) {
//   const lastProductUrl = sessionStorage.getItem('kg_last_product_url');
//   if (lastProductUrl) {
//     window.location.replace(lastProductUrl + window.location.search);
//   }
// }

